// extracted by mini-css-extract-plugin
module.exports = {"attention":"bq_fx"};